import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gps_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const fileUrl = (urlOrPath) => {
  if (!urlOrPath) return null;
  if (urlOrPath.startsWith("http")) return urlOrPath;
  if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
  return urlOrPath;
};
